import { CalendarContainer } from 'react-datepicker';
import Styles from './CustomDate.css';

export function CustomDateContainer({ className, children }) {
  return (
    <div className="custom-date-container">
      <CalendarContainer className={className}>{children}</CalendarContainer>
      <style jsx global>
        {Styles}
      </style>
    </div>
  );
}
